// Portfolio data for Azzam Saud AlHarbi

export const profile = {
  name: "Azzam AlHarbi",
  firstName: "Azzam",
  lastName: "AlHarbi",
  title: "Artificial Intelligence Engineer",
  location: "Saudi Arabia",
  email: "azzamsaud.111@gmail.com",
  bio: "AI Engineer specialized in building production-ready intelligent systems — from Retrieval-Augmented Generation (RAG) and LLM agents, to NLP pipelines and end-to-end data products. I focus on solving real-world problems with practical, scalable solutions that deliver measurable impact.",
  available: true,
  socials: {
    github: "https://github.com/Azzam-Saud",
    linkedin: "https://linkedin.com/in/azzam-saud",
    email: "mailto:azzamsaud.111@gmail.com"
  }
};

export const stats = [
  { label: "Featured projects", value: "4+" },
  { label: "Professional certificates", value: "2" },
  { label: "GPA", value: "4.83/5" }
];

export const projects = [
  {
    id: "p1",
    slug: "vidtalk",
    title: "VidTalk",
    tagline: "Turn any video into an interactive learning experience",
    description:
      "AI-powered educational platform that transforms video content into interactive learning. Provides smart semantic search inside videos, auto-generated quizzes, and dynamic mind maps to enhance understanding and retention.",
    stack: ["Python", "FastAPI", "Whisper", "LangChain", "RAG", "React", "Vector DB"],
    year: "2025",
    type: "LLM · RAG",
    metric: "Interactive learning",
    featured: true,
    repo: "https://github.com/Azzam-Saud",
    demo: "#"
  },
  {
    id: "p2",
    slug: "takamul",
    title: "Takamul",
    tagline: "Customer data platform with intelligent analytics",
    description:
      "A digital platform designed to manage, analyze, and enhance customer data for companies. Delivers instant statistics and an optional detailed dashboard focused on customer reviews — helping businesses elevate the quality of services they offer.",
    stack: ["Python", "Django", "PostgreSQL", "PowerBI", "React", "NLP"],
    year: "2025",
    type: "Full-Stack · Analytics",
    metric: "End-to-end platform",
    featured: true,
    repo: "https://github.com/Azzam-Saud",
    demo: "#"
  },
  {
    id: "p3",
    slug: "reviews-analysis",
    title: "Automated Customer Reviews Analysis",
    tagline: "Sentiment, clustering & summarization at scale",
    description:
      "Automated NLP system for customer reviews analysis — sentiment classification, product category clustering, and review summarization to extract key insights from large volumes of user feedback.",
    stack: ["Python", "Transformers", "scikit-learn", "BERTopic", "Pandas", "spaCy"],
    year: "2024",
    type: "NLP · Analytics",
    metric: "Multi-task NLP",
    featured: false,
    repo: "https://github.com/Azzam-Saud",
    demo: "#"
  },
  {
    id: "p4",
    slug: "safe-drive",
    title: "Safe Drive",
    tagline: "Real-time drowsiness detection for safer roads",
    description:
      "Real-time drowsiness detection system using image processing to monitor driver alertness. Detects eye closure and head pose patterns, and triggers audio alerts the moment driver fatigue is detected.",
    stack: ["Python", "OpenCV", "dlib", "MediaPipe", "NumPy", "Pygame"],
    year: "2024",
    type: "Computer Vision",
    metric: "Real-time alerts",
    featured: false,
    repo: "https://github.com/Azzam-Saud",
    demo: "#"
  }
];

export const experience = [
  {
    id: "e1",
    role: "AI Engineer",
    company: "Saudi Electronic University",
    period: "Dec 2025 — Present",
    location: "Saudi Arabia",
    points: [
      "Designing and developing AI solutions using RAG and system integrations.",
      "Connecting multiple data sources to deliver intelligent, scalable, and production-ready AI systems.",
      "Building dashboards and AI-driven tooling that turn raw data into actionable insights."
    ]
  },
  {
    id: "e2",
    role: "AI Engineering Trainee",
    company: "Saudi Digital Academy",
    period: "Feb 2025 — May 2025",
    location: "Saudi Arabia",
    points: [
      "Completed an intensive AI Engineering Bootcamp focused on deep learning, RAG systems, and LLM-based agents.",
      "Gained hands-on experience building and deploying end-to-end AI solutions.",
      "Worked on real-world projects covering data pipelines, model training, and deployment."
    ]
  },
  {
    id: "e3",
    role: "AI Trainee",
    company: "Experts Vision Consulting",
    period: "Jul 2024 — Aug 2024",
    location: "Saudi Arabia",
    points: [
      "Completed intensive AI training across the core ML and deep learning stack.",
      "Awarded for outstanding performance among peers during the program.",
      "Developed valuable soft skills alongside practical, applied AI engineering skills."
    ]
  },
  {
    id: "e4",
    role: "Drone Club Leader",
    company: "University of Jeddah",
    period: "Sep 2023 — Jan 2024",
    location: "Jeddah, Saudi Arabia",
    points: [
      "Led a team of 3 committees with 30+ core team members and 170+ beneficiaries.",
      "Organized and managed workshops, courses, and meetings with domain experts.",
      "Strengthened leadership, team management, and event-organization skills."
    ]
  }
];

export const education = [
  {
    id: "ed1",
    degree: "Bachelor's degree in Artificial Intelligence",
    institution: "University of Jeddah",
    period: "Aug 2020 — Oct 2024",
    detail: "GPA: 4.83 / 5.00"
  }
];

export const professionalCertificates = [
  {
    id: "pc1",
    title: "Certified Associate · GenAI and LLMs",
    issuer: "NVIDIA",
    date: "Dec 2025",
    tag: "GenAI"
  },
  {
    id: "pc2",
    title: "Artificial Intelligence Engineer (AiE)",
    issuer: "ARTIBA — Artificial Intelligence Board of America",
    date: "Aug 2025",
    tag: "AI"
  }
];

export const courses = [
  {
    id: "co1",
    title: "Cloud Computing Engineer",
    issuer: "Alibaba Cloud × Tuwaiq Academy",
    date: "Mar 2026",
    tag: "Cloud"
  },
  {
    id: "co2",
    title: "The Advanced Pathways in Artificial Intelligence",
    issuer: "SDAIA",
    date: "Dec 2024",
    tag: "AI"
  },
  {
    id: "co3",
    title: "Exploratory Data Analysis for Machine Learning",
    issuer: "IBM",
    date: "Mar 2024",
    tag: "ML"
  },
  {
    id: "co4",
    title: "Python for Data Science, AI & Development",
    issuer: "IBM",
    date: "Aug 2023",
    tag: "Python"
  },
  {
    id: "co5",
    title: "Machine Learning with Python",
    issuer: "IBM",
    date: "Aug 2023",
    tag: "ML"
  },
  {
    id: "co6",
    title: "Introduction to Artificial Intelligence",
    issuer: "KAUST Academy",
    date: "Nov 2022",
    tag: "AI"
  }
];

export const languages = [
  { name: "Arabic", level: "Native", percent: 100 },
  { name: "English", level: "IELTS 6.0", percent: 75 }
];

export const technicalSkills = [
  {
    name: "Backend & Languages",
    items: ["Python", "Django", "FastAPI", "SQL"]
  },
  {
    name: "AI / NLP / LLMs",
    items: ["NLP", "RAG", "LLM", "LangChain", "Transformers"]
  },
  {
    name: "Data & BI",
    items: ["PowerBI", "SQL", "Pandas", "NumPy"]
  }
];

export const softSkills = [
  "Collaboration & Communication",
  "Team Leadership",
  "Adaptability & Flexibility"
];

export const navLinks = [
  { label: "Projects", href: "#projects" },
  { label: "Experience", href: "#experience" },
  { label: "Education", href: "#education" },
  { label: "Skills", href: "#skills" },
  { label: "Contact", href: "#contact" }
];
